import { render, staticRenderFns } from "./uploadCom.vue?vue&type=template&id=a12140f2&scoped=true&"
import script from "./uploadCom.vue?vue&type=script&lang=js&"
export * from "./uploadCom.vue?vue&type=script&lang=js&"
import style0 from "./uploadCom.vue?vue&type=style&index=0&id=a12140f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12140f2",
  null
  
)

component.options.__file = "uploadCom.vue"
export default component.exports